var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"ui-app-logo",style:({ height: _vm.getHeight }),attrs:{"src":_vm.src,"alt":_vm.$t('app-name')}})
}
var staticRenderFns = []

export { render, staticRenderFns }